// extracted by mini-css-extract-plugin
module.exports = {"card":"_sDEvnefi","header":"__AlP-jgI","textContent":"_QA7yhmG3","link":"_f0Lz2R1y","logo":"_fkyqZIld","image":"_59qlfOjh"};